// Service page content for Child visas.
// Sourced from docs/research/australian-visa-pathways.md §3.
// COMPLIANCE: sensitive (children, custody). Our role is strictly gathering and
// organising documents and evidence. A registered migration agent identifies the
// subclass, advises on consent and custody, and lodges. Never write that we
// address legal or custody requirements. No guarantees; no unverified figures.

const childVisa = {
  groupSlug: "family-partner",
  slug: "child-visa",
  title: "Child Visa",
  eyebrow: "Family & Partner",
  intro:
    "Child visas let a dependent child of an Australian citizen, permanent resident, or eligible New Zealand citizen parent live in Australia permanently. They cover children applying from overseas or onshore, and dependent children being added to a parent's partner visa.",

  chips: [
    { label: "Visa type", value: "Permanent residence" },
    { label: "Sponsor", value: "Australian parent" },
    { label: "Offshore", value: "Subclass 101" },
    { label: "Onshore", value: "Subclass 802" },
  ],

  whoFor: [
    "Dependent children of an Australian citizen, permanent resident, or eligible New Zealand citizen.",
    "Families completing a move where a child needs to join an Australian parent.",
    "Parents adding a dependent child to a provisional partner visa.",
  ],

  essentials: [
    {
      title: "A qualifying parent",
      detail:
        "The sponsoring parent must be an Australian citizen, permanent resident, or eligible New Zealand citizen.",
    },
    {
      title: "Dependency and age",
      detail:
        "The child must be under 18, or a full-time student under 25 and financially dependent, or have a qualifying incapacity.",
    },
    {
      title: "Onshore or offshore",
      detail:
        "Use the Subclass 101 from outside Australia or the Subclass 802 from within Australia. Both grant permanent residence.",
    },
    {
      title: "Adding a child to a partner visa",
      detail:
        "A dependent child can be added to a provisional partner visa (the Subclass 445) before the parent's permanent stage is decided.",
    },
    {
      title: "Evidence of the relationship",
      detail:
        "Birth certificates, custody and care arrangements, and dependency evidence support the application.",
    },
    {
      title: "Health and character",
      detail:
        "The usual health and character requirements apply, with arrangements appropriate to children.",
    },
  ],

  process: [
    {
      title: "Confirm the right subclass",
      detail:
        "A registered migration agent identifies whether an onshore, offshore, or dependent-child option fits your family.",
    },
    {
      title: "Gather the evidence",
      detail:
        "We help you assemble and organise proof of parentage, dependency, and care arrangements.",
    },
    {
      title: "Organise consent and custody documents",
      detail:
        "Where another parent has rights, we help you gather and organise the consent and custody documents, and a registered migration agent advises on what the case requires.",
    },
    {
      title: "Lodge the application",
      detail:
        "We prepare and organise a thorough file, and a registered migration agent lodges it and deals with the Department.",
    },
    {
      title: "Decision",
      detail:
        "The Department decides. If granted, the child visa is permanent residence.",
    },
  ],

  faqs: [
    {
      q: "How old can my child be?",
      a: "Generally the child must be under 18, or under 25 if a full-time student and financially dependent, or have a qualifying incapacity. A registered migration agent confirms which category fits your child.",
    },
    {
      q: "What if the other parent is not involved?",
      a: "Where another parent has custody or access rights, you usually need their consent or a legal arrangement. We help you gather and organise the relevant documents carefully, and a registered migration agent advises on the consent and custody requirements.",
    },
    {
      q: "Can I include my child in my own visa instead?",
      a: "Often yes. Dependent children can be included in or added to a parent's partner visa. A registered migration agent advises whether including the child or a separate child visa is the better route.",
    },
    {
      q: "Is a child visa permanent?",
      a: "Yes. The Subclass 101 and 802 child visas grant permanent residence on approval. The Department makes the decision based on the evidence provided.",
    },
  ],

  related: ["partner-visa", "parent-visa", "prospective-marriage-300"],

  lastVerified: "13 July 2026",
};

export default childVisa;
